import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucPhanDoanSanXuat } from 'src/app/shared/DanhMucPhanDoanSanXuat.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucPhanDoanSanXuatService extends BaseService{

    displayColumns001: string[] = ['STT', 'ID', 'Code', 'Name', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucPhanDoanSanXuat";
    }
}

